import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import Header from './Header';
import Footer from './Footer';
import CartSidebar from '../cart/CartSidebar';
import VoiceIndicator from '../voice/VoiceIndicator';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isOpen: isCartOpen } = useSelector((state: RootState) => state.cart);
  const { isListening, isProcessing } = useSelector((state: RootState) => state.voice);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 relative">
        {children}

        {/* Voice Indicator - floating overlay */}
        {(isListening || isProcessing) && (
          <VoiceIndicator />
        )}
      </main>

      <Footer />

      {/* Cart Sidebar */}
      <CartSidebar isOpen={isCartOpen} />
    </div>
  );
};

export default Layout;